var exports = {
  "a": "Box__3QnkAa",
  "w": "Box_1__ObYIij",
};

module.exports = exports;
